import { UserListSearchCriteria } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportDialogComponent } from '../../../../../ui-kit';

export class UserListLoad {
  public static readonly type = '[UserList] Load';

  constructor(public payload: UserListSearchCriteria) {}
}

export class UserListDownloadStart {
  public static readonly type = '[UserListExport] start';

  constructor(
    public payload: {
      name: string;
      filterView: Partial<UserListSearchCriteria>;
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
    },
  ) {}
}

export class UserListInitialState {
  public static readonly type = '[UserList] Set initial state';
}
